import React, { useContext } from "react";
import { Row, Col, Empty, Button, Typography, message } from "antd";
import { WishlistContext } from "../WishlistContext";
import { CartContext } from "../CartContext";
import { useNavigate } from "react-router-dom";
import { IconTrash, IconShoppingCart, IconEye } from "@tabler/icons-react";
import ProductCard from "../component/ProductCard";
import GlobalHeader from "../util/GlobalHeader";

const { Title, Text } = Typography;

const BuyerWishlist = () => {
    const { wishlist, toggleWishlist, loading } = useContext(WishlistContext);
    const { addToCart } = useContext(CartContext);
    const navigate = useNavigate();

    const handleRemove = async (productId) => {
        await toggleWishlist(productId);
    };

    const handleAddToCart = async (product) => {
        try {
            await addToCart(product._id || product.id, 1);
            message.success(`${product.name} added to cart!`);
        } catch (error) {
            message.error("Failed to add to cart");
        }
    };

    return (
        <div className="pcu-padding-0">
            <GlobalHeader title="My Wishlist">
                {(!wishlist.products || wishlist.products.filter(p => !!p).length === 0) ? (
                    <div className="pcu-padding-y-60 pcu-text-center">
                        <Empty
                            description={<Text type="secondary">Your wishlist is empty</Text>}
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                        />
                        <Button type="primary" onClick={() => navigate('/')} className="pcu-margin-top-16">
                            Start Shopping
                        </Button>
                    </div>
                ) : (
                    <Row gutter={[16, 16]}>
                        {wishlist.products.filter(p => !!p).map((product) => (
                            <Col xs={12} sm={12} md={8} lg={6} xl={4} key={product._id || product.id}>
                                <ProductCard product={product} />
                            </Col>
                        ))}
                    </Row>
                )}
            </GlobalHeader>
        </div>
    );
};

export default BuyerWishlist;
